import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { IMAGES, PUB } from "@/lib/data";

const LINKS = [
  { label: "Story", href: "#story" },
  { label: "Menu", href: "#menu" },
  { label: "Ferry", href: "#ferry" },
  { label: "Book a Table", href: "#book-table" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-background/90 backdrop-blur-md border-b-2 border-foreground" : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-5 md:px-8 h-16 md:h-20 flex items-center justify-between">
        <a href="#top" onClick={(e) => { e.preventDefault(); go("#top"); }} className="flex items-center gap-3" data-testid="nav-logo">
          <img src={IMAGES.logo} alt="Harbour Haze" className="h-11 w-11 md:h-12 md:w-12 object-contain" />
          <span className="font-head font-extrabold tracking-tight leading-none text-lg md:text-xl">
            {PUB.name}
          </span>
        </a>

        <div className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-${l.href.slice(1)}`}
              onClick={() => go(l.href)}
              className="overline hover:text-secondary transition-colors"
            >
              {l.label}
            </button>
          ))}
        </div>

        <button
          className="lg:hidden p-2 border-2 border-foreground rounded-lg"
          onClick={() => setOpen((o) => !o)}
          data-testid="nav-mobile-toggle"
          aria-label="Menu"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </nav>

      {open && (
        <div className="lg:hidden bg-background border-b-2 border-foreground px-5 pb-6 pt-2 flex flex-col gap-1">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-mobile-${l.href.slice(1)}`}
              onClick={() => go(l.href)}
              className="text-left font-head font-bold text-2xl py-2 border-b border-foreground/10"
            >
              {l.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
}
